import React from "react";
import { Check, X } from "react-feather";
import { getFormattedDateString, hasPermission } from "utility/helpers";
import { UncontrolledTooltip } from "reactstrap";
import {
  StyledEditIcon,
  StyledEyeIcon,
  StyledTrashIcon,
  ViewCommentBtn,
  AddCommentBtn,
  CellText,
} from "assets/js/Styles";
import styled from "styled-components";
import { EDIT_ACTION, VIEW_ACTION } from "constants/actions";

const CommentsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  position: relative;

  &:has(.unread-msgs) {
    bottom: 10px;
  }
`;

const newsColumns = ({
  fetchComments,
  setCommentId,
  toggleModal,
  navigate,
  handleDeleteRow,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      style: { paddingLeft: 0, paddingRight: 0 },
      cell: () => null,
    },
    {
      name: "News Heading",
      selector: null,
      sortable: false,
      minWidth: "180px",
      cell: ({ title }) => <CellText>{title}</CellText>,
    },
    {
      name: "Date",
      selector: null,
      sortable: false,
      minWidth: "120px",
      cell: ({ createdAt }) => (
        <CellText>{getFormattedDateString(createdAt, "MMM dd, yyyy")}</CellText>
      ),
    },
    {
      name: "Include COS",
      selector: null,
      sortable: false,
      minWidth: "110px",
      cell: ({ includeCOS }) => (
        <CellText>
          {includeCOS ? <Check size={16} /> : <X size={16} />}
        </CellText>
      ),
    },
    {
      name: "Send with SMS",
      selector: null,
      sortable: false,
      minWidth: "130px",
      cell: ({ sendWithSMS }) => (
        <CellText>
          {sendWithSMS ? <Check size={16} /> : <X size={16} />}
        </CellText>
      ),
    },
    {
      name: "Send with Email",
      selector: null,
      sortable: false,
      minWidth: "135px",
      cell: ({ sendWithEmail }) => (
        <CellText>
          {sendWithEmail ? <Check size={16} /> : <X size={16} />}
        </CellText>
      ),
    },
    {
      name: "Remarks",
      selector: null,
      sortable: false,
      minWidth: "160px",
      cell: ({ hasComments, id }) => (
        <CommentsContainer>
          {hasComments ? (
            <ViewCommentBtn
              color="primary"
              size="sm"
              onClick={() => {
                fetchComments(id);
                setCommentId(id);
                toggleModal();
              }}
            >
              {"View Comment"}
            </ViewCommentBtn>
          ) : (
            <AddCommentBtn
              size="sm"
              onClick={() => {
                setCommentId(id);
                toggleModal();
              }}
            >
              {"Add Comment"}
            </AddCommentBtn>
          )}
        </CommentsContainer>
      ),
    },
    {
      name: "Actions",
      selector: null,
      sortable: false,
      cell: (row) => {
        return (
          <>
            {row?.isSent && hasPermission("news-update") && (
              <>
                <StyledEditIcon
                  size={16}
                  id={`edit-row--${row.id}`}
                  onClick={() => {
                    navigate("/news/edit", {
                      state: {
                        row,
                        action: EDIT_ACTION,
                      },
                    });
                  }}
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`edit-row--${row.id}`}
                >
                  {"Edit"}
                </UncontrolledTooltip>
              </>
            )}

            <StyledEyeIcon
              size={16}
              onClick={() =>
                navigate("/news/view", {
                  state: {
                    row,
                    action: VIEW_ACTION,
                  },
                })
              }
              id={`view-row--${row.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`view-row--${row.id}`}
            >
              {"View"}
            </UncontrolledTooltip>

            {hasPermission("news-delete") && (
              <>
                <StyledTrashIcon
                  size={16}
                  onClick={() => handleDeleteRow(row)}
                  id={`delete-row--${row.id}`}
                />
                <UncontrolledTooltip
                  placement="right"
                  target={`delete-row--${row.id}`}
                >
                  {"Delete"}
                </UncontrolledTooltip>
              </>
            )}
          </>
        );
      },
    },
  ];
};

export default newsColumns;
